import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Result, Typography } from 'antd';
import './Error.css';
const { Paragraph, Text } = Typography;

const App = ({ title, text }) => (
  <Result
    status="error"
    title={title}
    subTitle={text}
  >
    <div className="desc">
      <Paragraph>
        <Text
          strong
          style={{
            fontSize: 16,
          }}
        >
          The content you are accessing produced an error:
        </Text>
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> Your account authorization might have changed. Try logging out, and back in again.
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> The server might be overloaded or restarting. Try again later.
      </Paragraph>
    </div>
  </Result>
);
export default App;